import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Spinner } from '@chakra-ui/react';
export var CenteredLoader = function CenteredLoader() {
  return /*#__PURE__*/_jsx(Center, {
    children: /*#__PURE__*/_jsx(Spinner, {})
  });
};
export default CenteredLoader;